import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form-item-content" }
const _hoisted_3 = { class: "form-item-content" }
const _hoisted_4 = { class: "form-item-content" }
const _hoisted_5 = { class: "form-item-content" }
const _hoisted_6 = { class: "form-item-content" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }

import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { ProductService } from "@/api/services/ProductService";
import { ToImage } from "@/utils/image";
import { Product } from "@/api/models/product/Product";
import { ProductListRequest } from "@/api/models/product/ProductListRequest";
import { ProductUpdateRequest } from "@/api/models/product/ProductUpdateRequest";
import { ProductAddRequest } from "@/api/models/product/ProductAddRequest";
import { Moment } from "moment/moment";
import { Category } from "@/api/models/catrgory/Category";
import { CategoryService } from "@/api/services/CategoryService";
import FilesUpload from "@/components/FilesUpload.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductStock',
  setup(__props) {

dayjs.locale("zh-cn");

const total = ref<number>(0);

const listRequest = reactive<ProductListRequest>({
  current: 1,
  size: 20,
  content: "",
  status: 3,
});

const createAtChange = (_: Moment, mode: string) => {
  listRequest.start_time = Date.parse(mode);
};

const updateAtChange = (_: Moment, mode: string) => {
  listRequest.end_time = Date.parse(mode);
};

const productList = ref<Product[]>([]);

const handleList = async () => {
  const res = await ProductService.ListAll(listRequest);
  if (res.code === 0) {
    productList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const resetSearch = () => {
  listRequest.current = 1;
  listRequest.size = 20;
  listRequest.content = "";
  listRequest.category_id = 0;
  listRequest.start_time = 0;
  listRequest.end_time = 0;
  handleList();
};

const categoryList = ref<Category[]>([]);

const handleCategory = async () => {
  const res = await CategoryService.ListAll({
    current: 1,
    size: 1000000,
    content: "",
  });
  if (res.code === 0) {
    categoryList.value = res.data.records;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
  await handleCategory();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openAdd = ref(false);

const addRequest = reactive<ProductAddRequest>({
  name: "",
  description: "",
  content: "",
  price: 0,
  before_price: 0,
  fright: 0,
  image_url: [],
  status: 1,
  stock: 0,
  sold_count: 0,
  specification: "",
});

const handleAdd = () => {
  openAdd.value = true;
};

const submitAdd = async () => {
  const res = await ProductService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<ProductUpdateRequest>({
  id: 0,
  name: "",
  is_delete: 0,
  description: "",
  content: "",
  price: 0,
  before_price: 0,
  fright: 0,
  image_url: [],
  category_id: 0,
  status: 0,
  sold_count: 0,
  specification: "",
});

const handleUpdate = (record: Product) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
};

const submitUpdate = async () => {
  const res = await ProductService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Product) => {
  const res = await ProductService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Product) => {
  const res = await ProductService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "商品名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "描述",
    dataIndex: "description",
    align: "center",
  },
  {
    title: "详细内容",
    dataIndex: "content",
    align: "center",
  },
  {
    title: "价格",
    dataIndex: "price",
    align: "center",
  },
  {
    title: "打折前的价格",
    dataIndex: "before_price",
    align: "center",
  },
  {
    title: "类别",
    dataIndex: "category",
    align: "center",
  },
  {
    title: "运费",
    dataIndex: "fright",
    align: "center",
  },
  {
    title: "图片",
    dataIndex: "image_url",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "修改时间",
    dataIndex: "update_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        model: handleList,
        class: "search-form",
        onSubmit: handleList
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: handleAdd
                }, {
                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                    _createTextVNode("添加商品")
                  ])),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "status" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "label" }, "商品分类：", -1)),
                _createVNode(_component_a_select, {
                  style: {"width":"200px"},
                  value: listRequest.category_id,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((listRequest.category_id) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, (category) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: category.id,
                        value: category.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(category.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "content" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "label" }, "搜索内容：", -1)),
                _createVNode(_component_a_input, {
                  placeholder: "商品描述/商品详细",
                  value: listRequest.content,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((listRequest.content) = $event))
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "create_at" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "label" }, "创建时间：", -1)),
                _createVNode(_component_a_date_picker, {
                  placeholder: "选择时间",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "show-time": { defaultValue: _unref(dayjs)('00:00:00', 'HH:mm:ss') },
                  onChange: createAtChange
                }, null, 8, ["show-time"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "update_at" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "label" }, "修改时间：", -1)),
                _createVNode(_component_a_date_picker, {
                  placeholder: "选择时间",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "show-time": { defaultValue: _unref(dayjs)('00:00:00', 'HH:mm:ss') },
                  onChange: updateAtChange
                }, null, 8, ["show-time"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit"
              }, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [
                  _createTextVNode("搜索")
                ])),
                _: 1
              }),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: resetSearch
              }, {
                default: _withCtx(() => _cache[35] || (_cache[35] = [
                  _createTextVNode("重置")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_a_table, {
        columns: columns,
        "data-source": productList.value,
        pagination: {
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total.value,
        defaultPageSize: listRequest.size,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      },
        bordered: ""
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.dataIndex === 'is_delete')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (record.is_delete === 1)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "green"
                    }, {
                      default: _withCtx(() => _cache[36] || (_cache[36] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (record.is_delete === 2)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 1,
                      color: "red"
                    }, {
                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : (column.dataIndex === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.status === 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "green"
                      }, {
                        default: _withCtx(() => _cache[38] || (_cache[38] = [
                          _createTextVNode("可用")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status === 2)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "red"
                      }, {
                        default: _withCtx(() => _cache[39] || (_cache[39] = [
                          _createTextVNode("禁用")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (column.dataIndex === 'image_url')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(record.image_url.slice(0, 2), (i) => {
                    return (_openBlock(), _createBlock(_component_a_image, {
                      key: i,
                      src: _unref(ToImage)(i),
                      style: {"height":"60px","width":"auto"}
                    }, null, 8, ["src"]))
                  }), 128))
                : (column.dataIndex === 'create_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                  : (column.dataIndex === 'update_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(dayjs)(record.update_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                    : (column.dataIndex === 'operator')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _createVNode(_component_a_button, {
                            onClick: ($event: any) => (handleUpdate(record)),
                            type: "primary",
                            style: { marginRight: '8px' }
                          }, {
                            default: _withCtx(() => _cache[40] || (_cache[40] = [
                              _createTextVNode("编辑 ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_button, {
                            onClick: ($event: any) => (submitDelete(record)),
                            type: "primary",
                            style: {
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }
                          }, {
                            default: _withCtx(() => _cache[41] || (_cache[41] = [
                              _createTextVNode("删除 ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_button, {
                            onClick: ($event: any) => (submitDrop(record)),
                            type: "primary",
                            style: {
              backgroundColor: '#ff4d4f',
              color: 'white',
            }
                          }, {
                            default: _withCtx(() => _cache[42] || (_cache[42] = [
                              _createTextVNode("彻底删除 ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ], 64))
                      : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-source", "pagination"]),
      _createVNode(_component_a_modal, {
        open: openAdd.value,
        "onUpdate:open": _cache[14] || (_cache[14] = ($event: any) => ((openAdd).value = $event)),
        title: "添加商品数据",
        onOk: submitAdd,
        cancelText: "取消",
        width: "1000px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { model: addRequest }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "商品名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: addRequest.name,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((addRequest.name) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品描述" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: addRequest.description,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((addRequest.description) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品详情" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: addRequest.content,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((addRequest.content) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品价格" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: addRequest.price,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((addRequest.price) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品打折前的价格" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: addRequest.before_price,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((addRequest.before_price) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品规格" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: addRequest.specification,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((addRequest.specification) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品运费" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: addRequest.fright,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((addRequest.fright) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品库存" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: addRequest.stock,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((addRequest.stock) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "已售数量" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: addRequest.sold_count,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((addRequest.sold_count) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "出售状态" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: addRequest.status,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((addRequest.status) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => _cache[43] || (_cache[43] = [
                          _createTextVNode("待审核")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 2 }, {
                        default: _withCtx(() => _cache[44] || (_cache[44] = [
                          _createTextVNode("出售中")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 3 }, {
                        default: _withCtx(() => _cache[45] || (_cache[45] = [
                          _createTextVNode("仓库中")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 4 }, {
                        default: _withCtx(() => _cache[46] || (_cache[46] = [
                          _createTextVNode("下架")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "类别" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: addRequest.category_id,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((addRequest.category_id) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, (category) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: category.id,
                          value: category.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(category.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "图片" }, {
                default: _withCtx(() => [
                  _createVNode(FilesUpload, {
                    modelValue: addRequest.image_url,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((addRequest.image_url) = $event)),
                    style: {"display":"block"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_component_a_modal, {
        open: openUpdate.value,
        "onUpdate:open": _cache[28] || (_cache[28] = ($event: any) => ((openUpdate).value = $event)),
        title: "修改会员数据",
        onOk: submitUpdate,
        cancelText: "取消",
        width: "1000px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            model: updateRequest,
            style: {"margin-top":"20px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "商品名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: updateRequest.name,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((updateRequest.name) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品描述" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: updateRequest.description,
                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((updateRequest.description) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品详情" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: updateRequest.content,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((updateRequest.content) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品价格" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: updateRequest.price,
                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((updateRequest.price) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品打折前的价格" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: updateRequest.before_price,
                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((updateRequest.before_price) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品规格" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: updateRequest.specification,
                    "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((updateRequest.specification) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品运费" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: updateRequest.fright,
                    "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((updateRequest.fright) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "商品库存" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: updateRequest.stock,
                    "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((updateRequest.stock) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "已售数量" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: updateRequest.sold_count,
                    "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((updateRequest.sold_count) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "出售状态" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: updateRequest.status,
                    "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((updateRequest.status) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => _cache[47] || (_cache[47] = [
                          _createTextVNode("待审核")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 2 }, {
                        default: _withCtx(() => _cache[48] || (_cache[48] = [
                          _createTextVNode("出售中")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 3 }, {
                        default: _withCtx(() => _cache[49] || (_cache[49] = [
                          _createTextVNode("仓库中")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 4 }, {
                        default: _withCtx(() => _cache[50] || (_cache[50] = [
                          _createTextVNode("下架")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "类别" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: updateRequest.category_id,
                    "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((updateRequest.category_id) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, (category) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: category.id,
                          value: category.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(category.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "图片" }, {
                default: _withCtx(() => [
                  _createVNode(FilesUpload, {
                    modelValue: updateRequest.image_url,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((updateRequest.image_url) = $event)),
                    style: {"display":"block"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "状态" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: updateRequest.is_delete,
                    "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((updateRequest.is_delete) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => _cache[51] || (_cache[51] = [
                          _createTextVNode("正常")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 2 }, {
                        default: _withCtx(() => _cache[52] || (_cache[52] = [
                          _createTextVNode("回收站")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["open"])
    ])
  ], 64))
}
}

})